export default window._env;
